var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"baseLayout"},[_c('deal-info'),_c('b-tabs',{model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},_vm._l((_vm.links),function(link,index){return _c('b-tab',{key:index,attrs:{"title":link.name,"active":""}})}),1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }